module.exports = __webpack_public_path__ + "assets/c04b123270bdf764dcd3cd8ec743e56e.png";